import React from "react";
import { servicios } from "../../../datos";

export function Servicios() {
  // destructe servicios
  const { title, subtitle, list } = servicios;
  return (
    <section className="my-[70px] xl:my-[150px]">
      <div className="container mx-auto">
        {/* text title */}
        <div className="text-center">
          <h2
            className="h2 mb-0 xl:mb-0"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            {title}
          </h2>
          <p
            className="lead max-w-[980px] mx-auto mb-16 xl:mb-24 text-2xl"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            {subtitle}
          </p>
        </div>
        {/* Listado de Imagenes o Card */}
        <div className="grid grid-cols-1 gap-[50px] xl:grid-cols-2 mt-6">
          {list?.map((item, index) => {
            // destructe item
            const { image, title, delay, descripcion, imageGb } = item;
            // item
            return (
              <div
                key={index}
                className="w-full max-w-[530px] h-[358px] relative flex flex-col items-center justify-center xl:flex-row xl:justify-start mx-auto"
                data-aos="zoom-in"
                data-aos-offset="100"
                data-aos-delay={delay}
              >
                {/* bg image */}
                <div className="hidden xl:flex absolute top-0 right-0 -z-10">
                  <img src={imageGb} alt={title} />
                </div>
                <div
                  className="max-w-[120px] xl:mr-7 xl:max-w-[232px]"
                  data-aos="zoom-in-right"
                  data-aos-delay={delay}
                >
                  <img src={image} alt={title} />
                </div>
                {/* Text */}
                <div className="max-w-[220px]">
                  <h3 className="h3 mb-4 text-3xl font-bold">{title}</h3>
                  <p className="font-black text-2xl italic mb-4">
                    {descripcion}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
